import { GetterTree } from 'vuex'
import { ApiState } from './modules/api'

interface RootState {
  api: ApiState
}

const getters: GetterTree<RootState, RootState> = {
  // count: (state) => state.app.count,
  // swiperIndex: (state) => state.app.swiperIndex,
  // hamburgerActive: (state) => state.app.hamburgerActive,
  // token: (state) => state.user.token,
  // userInfo: (state) => state.user.userInfo
}

export default getters
